<template>
  <div
    class="pchips pchips_cont"
    :class="{
      pchips_empty: !bet,
    }"
  >
    <div
      v-for="(column, wcIdx) in coinColumns"
      :key="`${wcIdx}_column`"
      class="pchips_column anim-coin-column"
    >
      <div
        v-for="(coin, cIdx) in column.coins"
        :key="`${cIdx}_coin`"
        :class="`pchips_coin_${coin * 10}`"
        class="pchips_coin anim-fade-in"
      ></div>
      <!-- style="--anim-duration: 0.44s; --anim-height: var(--coin-size)" -->
      <!-- class="pchips_coin anim-max-height" -->
    </div>
  </div>
</template>

<script>
import { getChipNominations } from '@/store/gamestate/gamestate'

export default {
  name: 'PokerChips',
  props: {
    // chipsGroupedByNomination: Array,
    bet: Number,
  },

  computed: {
    coinColumns() {
      if (!this.bet) return []

      const nominationGroups = getChipNominations({ amount: this.bet || 0 })
      // console.log(nominationGroups)
      const coinGroups = nominationGroups.map(i => {
        const id = i.nomination.toString()
        return {
          id,
          coins: [...new Array(i.amount).keys()].map(_ => id),
        }
      })

      const coinsStacked = coinGroups.reduce((a, b) => [...a, ...b.coins], [])

      // coinsStacked = coinsStacked.sort((a, b) => b - b)
      let res = [
        {
          id: 'all',
          coins: coinsStacked,
        },
      ]
      const cl = coinsStacked.length
      if (cl < 5) {
        return res
      }

      const columns = cl / 2 > 6 ? 3 : 2
      const maxColumnCoins = Math.ceil(cl / columns)

      // console.log(coinGroups, coinsStacked, res, maxColumnCoins)

      if (columns === 2) {
        const first = coinsStacked.slice(0, maxColumnCoins)
        const second = coinsStacked.slice(maxColumnCoins)
        res = [
          {
            id: 'first',
            coins: first,
          },
          {
            id: 'second',
            coins: second,
          },
        ]
      } else {
        const first = coinsStacked.slice(0, maxColumnCoins)
        const second = coinsStacked.slice(maxColumnCoins, maxColumnCoins * 2)
        const third = coinsStacked.slice(maxColumnCoins * 2)
        res = [
          {
            id: 'first',
            coins: first,
          },
          {
            id: 'second',
            coins: second,
          },
          {
            id: 'third',
            coins: third,
          },
        ]
      }

      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.pchips {
  --coin-size: 0.8em;
  --column-width: calc(0.68 * var(--coin-size));

  --chips-max-height: var(--coin-size);
  --coin-overlap-top: calc(-0.75 * var(--coin-size));
  --clr-coin: grey;
  --clr-coin-1000: var(--clr-yellow);
  --clr-coin-500: var(--clr-pink);
  --clr-coin-250: var(--clr-primary-1);
  --clr-coin-50: var(--clr-error);
  --clr-coin-10: var(--clr-blue-1);
  --clr-coin-5: var(--clr-blue);
  // &_empty {
  //   margin: 0 !important;
  // }
  &_cont {
    position: relative;
    display: flex;
    // flex-direction: row-reverse;
    max-height: var(--chips-max-height);

    // justify-content: center;
    // align-items: center;
    z-index: 1;
    // background: red;
  }
  &_column {
    // background: blue;
    position: relative;
    display: flex;
    flex-direction: column-reverse;

    --anim-duration: 0.44s;
    width: var(--column-width);
    animation: animCoinColumn var(--anim-duration);
    will-change: max-width;
  }

  @keyframes animCoinColumn {
    0% {
      max-width: 0px;
    }
    100% {
      max-width: var(--column-width);
    }
  }
  &_coin {
    position: relative;
    z-index: 1;
    height: var(--coin-size);
    width: var(--coin-size);
    box-shadow: -0.66px 1px 0px var(--clr-black-1);
    // box-shadow: 0px 1px 0px var(--clr-black-1);
    background: var(--clr-coin);
    border-radius: 50%;
    flex-shrink: 0;
    margin: 0 0 var(--coin-overlap-top) 0;
    &:nth-child(1) {
      margin: 0;
    }
    &_1000 {
      --clr-coin: var(--clr-coin-1000);
    }
    &_500 {
      --clr-coin: var(--clr-coin-500);
    }
    &_250 {
      --clr-coin: var(--clr-coin-250);
    }
    &_50 {
      --clr-coin: var(--clr-coin-50);
    }
    &_10 {
      --clr-coin: var(--clr-coin-10);
    }
    &_5 {
      --clr-coin: var(--clr-coin-5);
    }
  }
}
</style>
